<div class="row" *appRequirePermission="id() ? ['financeInformation'] : []">
  <div class="col-12 col-md-6 mb-3">
    <div class="row align-items-center">
      <div class="col-12 col-sm-4 mb-1">
        <label for="paymentType">{{
          'serviceData.form.paymentType' | translate
        }}</label>
      </div>
      <div class="col-12 col-sm-8">
        @if (paymentTypes$ | async; as paymentTypes) {
          <app-select
            class="w-100"
            id="paymentType"
            appInputValidationStatus
            formControlName="paymentType"
            data-cy="PaymentType-select"
            [placeholder]="
              'serviceData.form.placeholders.paymentType' | translate
            "
          >
            @for (type of paymentTypes; track type) {
              <app-select-option
                [value]="PaymentType[type]"
                [label]="PaymentType[type]"
              />
            }
          </app-select>
        } @else {
          <app-select
            [placeholder]="
              'serviceData.form.placeholders.selectPartnerFirst' | translate
            "
            formControlName="paymentType"
            data-cy="PaymentType-select-disabled"
          />
        }
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-12 col-sm-8">
        <app-validation-error
          for="paymentType"
          translations="validation.generic"
          data-cy="PaymentType-validation-error"
        ></app-validation-error>
      </div>
    </div>
  </div>
  @if (
    form.get('paymentType').value === PaymentType.Customer1 ||
    form.get('paymentType').value === PaymentType.Customer2
  ) {
    <div class="col-12 col-md-6 mb-3">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label for="notes">{{ 'serviceData.form.payer' | translate }}</label>
        </div>
        <div class="col-12 col-sm-8">
          <input
            class="form-control"
            id="payer"
            formControlName="notes"
            [placeholder]="'serviceData.form.placeholders.payer' | translate"
            data-cy="Payer-input"
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          <app-validation-error
            for="notes"
            translations="validation.generic"
            data-cy="Payer-validation-error"
          ></app-validation-error>
        </div>
      </div>
    </div>
  }
</div>
<div class="row">
  <div class="col-12 col-md-6 mb-3 align-self-center">
    <div class="row align-items-center">
      <div class="col-12 col-sm-4 mb-1">
        <label for="doctorInvoiceNumber">{{
          'serviceData.form.doctorInvoiceNumber' | translate
        }}</label>
      </div>
      <div class="col-12 col-sm-8">
        <input
          class="form-control"
          id="doctorInvoiceNumber"
          formControlName="doctorInvoiceNumber"
          [placeholder]="
            'serviceData.form.placeholders.doctorInvoiceNumber' | translate
          "
          data-cy="DoctorInvoiceNumber-input"
        />
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-12 col-sm-8">
        <app-validation-error
          for="doctorInvoiceNumber"
          translations="validation.generic"
          data-cy="DoctorInvoiceNumber-validation-error"
        ></app-validation-error>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-6 mb-3">
    <div class="row align-items-center">
      <div class="col-12 col-sm-4 mb-1">
        <label for="laboratoryInvoiceNumber">{{
          'serviceData.form.laboratoryInvoiceNumber' | translate
        }}</label>
      </div>
      <div class="col-12 col-sm-8">
        <input
          class="form-control"
          id="laboratoryInvoiceNumber"
          formControlName="laboratoryInvoiceNumber"
          [placeholder]="
            'serviceData.form.placeholders.laboratoryInvoiceNumber' | translate
          "
          data-cy="LaboratoryInvoiceNumber-input"
        />
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-12 col-sm-8">
        <app-validation-error
          for="laboratoryInvoiceNumber"
          translations="validation.generic"
          data-cy="LaboratoryInvoiceNumber-validation-error"
        ></app-validation-error>
      </div>
    </div>
  </div>
</div>
